import '../css/reset.css';
import '../css/common.css';
import '../css/partnerJoin.css';
import {
  requestGET,
  requestPOST,
  popupOpen,
  setJWTTokenData,
  setJWTUserData,
  validateEmail,
  API_URL,
  OLD_API_URL,
} from './common-es6';

const partnerId = document.getElementById('partnerId');
const partnerPw = document.getElementById('partnerPw');
const partnerPwCheck = document.getElementById('partnerPwCheck');
const partnerName = document.getElementById('partnerName');
const partnerBirth = document.getElementById('partnerBirth');
const partnerTel = document.getElementById('partnerTel');
const partnerEmail = document.getElementById('partnerEmail');
const btnJoinSubmit = document.getElementById('btnJoinSubmit');
const idMessage = document.getElementById('idMessage');
const pwMessage = document.getElementById('pwMessage');
const pwCheckMessage = document.getElementById('pwCheckMessage');
const nameCheckMessage = document.getElementById('nameCheckMessage');
const birthCheckMessage = document.getElementById('birthCheckMessage');
const genderCheckMessage = document.getElementById('genderCheckMessage');
const telCheckMessage = document.getElementById('telCheckMessage');
const emailCheckMessage = document.getElementById('emailCheckMessage');
const termsCheckbox = document.getElementById('termsCheckbox');
const popupPartnerJoinGuide = document.getElementById('popupPartnerJoinGuide');
const radioGenderM = document.getElementById('radioGenderM');
const radioGenderW = document.getElementById('radioGenderW');
const btnPopupMarketing = document.getElementById('btnPopupMarketing');
const btnCheckOverlap = document.getElementById('btnCheckOverlap');
const btnCheckEmailOverlap = document.getElementById('btnCheckEmailOverlap');
const eventAgreeCheckbox = document.getElementById('eventAgreeCheckbox');
const popupNoticeSubmitErr = document.getElementById('popupNoticeSubmitErr');
const popupLevelGuide = document.getElementById('popupLevelGuide');
const popupPartnerMarketing = document.getElementById('popupPartnerMarketing');

/**
 * 정규표현식 RegExp
 * 아이디 - 유효성검사 - 영문 숫자 조합 / 특수문자 포함된 경우 오류메시지 - check
 * 아이디 - 중복확인 필수 / 중복확인 버튼 클릭시 중복인 경우, 사용가능한 경우, 유효성검사에 맞지 않는 경우
 * 비밀번호 - 유효성 검사 - 영문 + 숫자 + 특수문자 + 6~14자 - check
 * 비밀번호 오류메시지 - 입력하지 않은 경우 / 유효성검사에 맞지 않는 경우
 * 비밀번호 확인 - 오류메시지 - 비밀번호 입력과 일치하지 않는 경우
 * 이름 - 유효성검사 - 특수문자 x 최소 2글자 - check
 * 이름 - 오류 메시지 - 특수문자가 포함된 경우 / 1글자만 입력한 경우
 * 생년월일 - 유효성검사 - 생년월일 8자리 숫자 - check
 * 생년월일 - 오류 메시지 - 유효성검사 맞지 않는 경우
 * 성별 미 체크 - 오류메시지 - 가입하기 클릭시 미입력 체크
 * 휴대폰번호 - 유효성검사 - 10자리미만인 경우
 * 이메일 - 유효성검사 - @입력 없고, 5자리 미만의 텍스트 입력시
 * 이메일 - 오류메시지 - 유효성검사 맞지 않는 경우 / 이메일이 중복된 경우
 * */

/**
 * 정규표현식 validate / RegExp / _check
 */
// 아이디 - 영문과 숫자, 6~14자 체크
const validateId = (id) => (/^[a-z0-9]{6,14}$/.test(id)) && (/[a-z]/g.test(id)) && (/[0-9]/g.test(id));

// 특수문자 검색
const validateSpacial = (name) => /[~!@\#$%<>^&*\()\-=+_\’]/gi.test(name);

// 정규식표현 - 비밀번호 - 영문 + 숫자 + 특수문자 + 6~14자 !@#$%^&*?()_~
const validatePw = (pw) => /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*?()_~])[A-Za-z\d!@#$%^&*?()_~]{6,14}$/.test(pw);

// 정규식표현 - 이름 - 2글자 이상 + 특수문자 제외
const validateName = (name) => /^[a-zA-Zㄱ-힣]{2,}$/.test(name);

// 정규식표현 - 생년월일 - 8자리
const validateBirth = (birth) => {
  birth = birth.replace(/[^0-9]/g, '');
  return /^[0-9]{4}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/.test(birth);
};

// 정규식표현 - 휴대폰번호 - 숫자, 10자리 이상, 하이픈은 입력해도 숫자만 저장
const validateTel = (tel) => {
  tel = tel.replace(/[^0-9]/g, '');
  return /^[0-9]{10,}/gi.test(tel);
};

// 1개 이상의 숫자 포함
const validateNumber = (text) => /[0-9]/.test(text);

// 1개 이상의 영문 포함
const validateEnglish = (text) => /[A-Za-z]/.test(text);

// 비밀번호 특수문자 포함
const validatePwSpacial = (name) => /[!@#$%^&*?()_~]/gi.test(name);

let isValidId = false;
let isValidPw = false;
let isValidPwCheck = false;
let isValidName = false;
let isValidBirth = false;
let isValidTel = false;
let isValidEmail = false;
let isGenderChecked = false;
let isTermsChecked = false;
let isIdOverlapCheck = false;
let isEmailOverlapCheck = false;
let isEventAgreeChecked = 0;

const setResultSuccessIdValid = (messageEl) => {
  isValidId = true;
  isIdOverlapCheck = true;
  messageEl.innerHTML = '<p class="input-box__under-message">* 사용할 수 있는 아이디입니다.</p>';
};

// 아이디 검사
// 중복확인 필수 / 중복확인 버튼 클릭시 중복인 경우, 사용가능한 경우, 유효성검사에 맞지 않는 경우
const idIsValid = (element, isValid, underMsg) => {
  const eleValue = element.value;

  if (eleValue) {
    if (isValid) {
      if (isIdOverlapCheck === false) {
        // 중복체크 안 했을 경우
        underMsg.innerHTML = '<p class="input-box__under-message--error">* 아이디 중복확인 바랍니다.</p>';
      } else {
        setResultSuccessIdValid(underMsg);
        // isValidId = true;
        // isIdOverlapCheck = true;
        // underMsg.innerHTML = '<p class="input-box__under-message">* 사용할 수 있는 아이디입니다.</p>';
      }
    } else {
      isValidId = false;
      underMsg.innerHTML = '<p class="input-box__under-message--error">* 6~14자 이내로 영문, 숫자를 조합하여 작성합니다.</p>';
    }
  } else {
    isValidId = false;
    underMsg.innerHTML = '<p class="input-box__under-message--error">* 아이디를 입력해주세요.</p>';
  }

  sendPartnerJoin();
};

// 아이디 중복 검사
// TODO : 아이디, 이메일 중복검사 api url을 같이 씀!!!
const NicknameOverlapCheck = (element, isValid) => {
  requestGET(`${OLD_API_URL}/sign/?type=isExistEmail&email=${partnerId.value}`, (status, resData) => {
    if (status) {
      const eleValue = element.value;
      if (eleValue) {
        if (isValid) {
          isValidId = true;
          if (resData.result) {
            isIdOverlapCheck = true;
            sendPartnerJoin();
            idMessage.innerHTML = '<p class="input-box__under-message">* 사용할 수 있는 아이디입니다.</p>';
          } else {
            isIdOverlapCheck = false;
            idMessage.innerHTML = '<p class="input-box__under-message--error">* 이미 사용 중인 아이디입니다.</p>';
          }
        } else {
          isValidId = false;
          isIdOverlapCheck = false;
          idMessage.innerHTML = '<p class="input-box__under-message--error">* 6~14자 이내로 영문, 숫자를 조합하여 작성합니다.</p>';
        }
      } else {
        isValidId = false;
        isIdOverlapCheck = false;
        idMessage.innerHTML = '<p class="input-box__under-message--error">* 아이디를 입력해주세요.</p>';
      }
    }
  });

  sendPartnerJoin();
};

// 이메일 중복 검사
const emailOverlapCheck = (element, isValid) => {
  requestGET(`${OLD_API_URL}/sign/?type=isExistEmail&email=${partnerEmail.value}`, (status, resData) => {
    if (status) {
      if (element.value) {
        if (isValid) {
          isValidEmail = true;

          if (resData.result) {
            isEmailOverlapCheck = true;
            sendPartnerJoin();
            emailCheckMessage.innerHTML = '<p class="input-box__under-message">* 사용할 수 있는 이메일입니다.</p>';
          } else {
            isEmailOverlapCheck = false;
            emailCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 이미 사용 중인 이메일입니다.</p>';
          }
        } else {
          isValidEmail = false;
          isEmailOverlapCheck = false;
          emailCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 올바른 이메일을 입력해주세요.</p>';
        }
      } else {
        isValidEmail = false;
        isEmailOverlapCheck = false;
        emailCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 심사결과가 메일로 전송됩니다. 반드시 수신 가능한 이메일을 입력해주세요.</p>';
      }
    }
  });

  sendPartnerJoin();
};

// 패스워드 검사
const pwIsValid = (element, isValid) => {
  const eleValue = element.value;

  if (eleValue) {
    if (isValid) {
      isValidPw = true;
      pwMessage.innerHTML = '';
    } else {
      isValidPw = false;
      pwMessage.innerHTML = '<p class="input-box__under-message--error">6~14자 이내로 영문, 숫자, 특수문자를 조합하여 작성합니다.</p>';

      // TODO: 한번 더 자세히 알려주기 영문, 숫자, 특수문자 따로
      if (validateNumber(element.value) === false) {
        alert('숫자를 같이 조합해주세요!');
        return false;
      }

      if (validateEnglish(element.value) === false) {
        alert('영문을 같이 조합해주세요!');
        return false;
      }

      if (validatePwSpacial(element.value) === false) {
        alert('사용 가능한 특수문자를 같이 조합해주세요!');
        return false;
      }
    }
  } else {
    isValidPw = false;
    pwMessage.innerHTML = '<p class="input-box__under-message--error">* 비밀번호를 입력해주세요.</p>';
  }

  sendPartnerJoin();
};

// 패스워드 재확인
const pwCheckIsValid = (element) => {
  const eleValue = element.value;

  if (eleValue) {
    if (partnerPw.value === partnerPwCheck.value) {
      isValidPwCheck = true;
      pwCheckMessage.innerHTML = '';
    } else {
      isValidPwCheck = false;
      pwCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 입력하신 비밀번호가 일치하지 않습니다.</p>';
    }
  } else {
    isValidPwCheck = false;
    pwCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 비밀번호를 한번 더 입력해주세요.</p>';
  }

  sendPartnerJoin();
};

// 이름 검사
const nameIsValid = (element, isValid) => {
  const eleValue = element.value;

  if (eleValue) {
    if (isValid) {
      isValidName = true;
      nameCheckMessage.innerHTML = '';
    } else {
      isValidName = false;
      if (validateSpacial(eleValue)) {
        // 특수문자 입력시
        nameCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 특수문자는 사용불가합니다.</p>';
      } else {
        nameCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 이름을 올바르게 입력해주세요.</p>';
      }
    }
  } else {
    isValidName = false;
    nameCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 이름을 입력해주세요.</p>';
  }
  sendPartnerJoin();
};

// 생년월일 검사
const birthIsValid = (element, isValid) => {
  const eleValue = element.value;
  if (eleValue) {
    if (isValid) {
      isValidBirth = true;
      birthCheckMessage.innerHTML = '';
    } else {
      isValidBirth = false;
      birthCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 8자리 숫자로 입력해주세요. 예) 19900123</p>';
    }
  } else {
    isValidBirth = false;
    birthCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 생년월일을 입력해주세요.</p>';
  }
  sendPartnerJoin();
};

// 휴대전화번호 검사 - 입력에서 '-' 제거
const telIsValid = (element, isValid) => {
  const eleValue = element.value;
  if (eleValue) {
    if (isValid) {
      isValidTel = true;
      telCheckMessage.innerHTML = '';
    } else {
      isValidTel = false;
      telCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 올바른 휴대전화번호를 입력해주세요.</p>';
    }
  } else {
    isValidTel = false;
    telCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 연락 가능한 휴대전화번호를 입력해주세요.</p>';
  }
  sendPartnerJoin();
};

// 이메일 검사 (유효성, 중복검사)
const emailIsValid = (element, isValid) => {
  const eleValue = element.value;
  if (eleValue) {
    if (isValid) {
      if (isEmailOverlapCheck === false) {
        // 중복체크 안 했을 경우
        emailCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 이메일 중복확인 바랍니다.</p>';
      } else {
        isValidEmail = true;
        isEmailOverlapCheck = true;
        emailCheckMessage.innerHTML = '<p class="input-box__under-message">* 사용할 수 있는 이메일입니다.</p>';
      }
    } else {
      isValidEmail = false;
      emailCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 올바른 이메일을 입력해주세요.</p>';
    }
  } else {
    isValidEmail = false;
    emailCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 심사결과가 메일로 전송됩니다. 반드시 수신 가능한 이메일을 입력해주세요.</p><p class="input-box__under-message--error">* 내담자로 가입한 이메일은 사용할 수 없습니다.</p>';
  }
  sendPartnerJoin();
};

let genderValue = '';
// 성별 체크 여부
// 성별은 라디오버튼이므로 누르기만 하면 true
const genderCheckStatus = () => {
  if ((radioGenderM.checked === true) || (radioGenderW.checked === true)) {
    for (let i = 0; i < document.querySelectorAll('input[name=gender]').length; i += 1) {
      if (document.querySelectorAll('input[name=gender]')[i].checked) {
        genderValue = document.querySelectorAll('input[name=gender]')[i].value;
        isGenderChecked = true;
        genderCheckMessage.innerHTML = '';
      }
    }
  } else {
    isGenderChecked = false;
    genderCheckMessage.innerHTML = '<p class="input-box__under-message--error">* 성별을 선택해주세요.</p>';
  }

  sendPartnerJoin();
};

// 필수 체크박스 체크 여부
const termsCheckStatus = () => {
  isTermsChecked = (termsCheckbox.checked === true);
  sendPartnerJoin();
};

// 이벤트 수신 체크 여부
const eventAgreeCheckStatus = () => {
  isEventAgreeChecked = (eventAgreeCheckbox.checked === true) ? 1 : 0;
  sendPartnerJoin();
};

// 모든 Valid 가 True 인지 검사 - 가입하기 버튼 활성화
let inputAllCheck = false;
const sendPartnerJoin = () => {
  if ((isValidId) && (isValidPw) && (isValidPwCheck) && (isValidName) && (isValidBirth) && (isValidTel) && (isValidEmail) && (isGenderChecked) && (isTermsChecked) && (isIdOverlapCheck) && (isEmailOverlapCheck)) {
    inputAllCheck = true;
    document.getElementById('btnJoinSubmit').classList.add('is-active');
  } else {
    inputAllCheck = false;
    document.getElementById('btnJoinSubmit').classList.remove('is-active');
  }
};

const getDataOfPartnerJoin = () => {
  if (partnerId) {
    partnerId.addEventListener('blur', () => {
      idIsValid(partnerId, validateId(partnerId.value), idMessage);
    });
  }

  if (partnerPw) {
    partnerPw.addEventListener('blur', () => {
      pwIsValid(partnerPw, validatePw(partnerPw.value));
    });
  }

  if (partnerPwCheck) {
    partnerPwCheck.addEventListener('blur', () => {
      pwCheckIsValid(partnerPwCheck);
    });
  }

  if (partnerName) {
    partnerName.addEventListener('blur', () => {
      nameIsValid(partnerName, validateName(partnerName.value));
    });
  }

  if (partnerBirth) {
    partnerBirth.addEventListener('blur', () => {
      birthIsValid(partnerBirth, validateBirth(partnerBirth.value));
    });
  }

  if (partnerTel) {
    partnerTel.addEventListener('blur', () => {
      telIsValid(partnerTel, validateTel(partnerTel.value));
    });
  }

  if (partnerEmail) {
    partnerEmail.addEventListener('blur', () => {
      emailIsValid(partnerEmail, validateEmail(partnerEmail.value));
    });
  }

  // 중복확인해서 OK 한 경우라도, 다시 input을 수정하면 중복확인을 다시 해야 함.
  if (partnerId) {
    partnerId.addEventListener('keyup', () => {
      isIdOverlapCheck = false;
    });
  }

  if (partnerEmail) {
    partnerEmail.addEventListener('keyup', () => {
      isEmailOverlapCheck = false;
    });
  }

  if (btnCheckOverlap) {
    btnCheckOverlap.addEventListener('click', () => {
      if (partnerId.value !== '') {
        NicknameOverlapCheck(partnerId, validateId(partnerId.value));
      } else {
        idMessage.innerHTML = '<p class="input-box__under-message--error">아이디를 입력해주세요.</p>';
      }
    });
  }

  if (btnCheckEmailOverlap) {
    btnCheckEmailOverlap.addEventListener('click', () => {
      if (partnerEmail.value !== '') {
        emailOverlapCheck(partnerEmail, validateEmail(partnerEmail.value));
      } else {
        emailCheckMessage.innerHTML = '<p class="input-box__under-message--error">이메일을 입력해주세요.</p>';
      }
    });
  }

  if (termsCheckbox) {
    termsCheckbox.addEventListener('click', () => {
      termsCheckStatus();
    });
  }

  if (eventAgreeCheckbox) {
    eventAgreeCheckbox.addEventListener('click', () => {
      eventAgreeCheckStatus();
    });
  }

  for (let i = 0; i < document.querySelectorAll('input[name=gender]').length; i += 1) {
    document.querySelectorAll('input[name=gender]')[i].addEventListener('click', () => {
      genderCheckStatus();
    });
  }

  if (btnPopupMarketing) {
    btnPopupMarketing.addEventListener('click', () => {
      popupOpen(popupPartnerMarketing);
    });
  }

  /**
   * input 입력은 입력 후 input out focus 되었을 때 값을 얻고, 라디오/체크박스는 가입하기 버튼을 눌러야 값을 받는다.
   * input 이 모두 true 인 상태에서 필수 입력과 성별 체크가 안 되어 있으면 에러메시지/팝업뜨기
   */

  if (btnJoinSubmit) {
    btnJoinSubmit.addEventListener('click', () => {
      if (inputAllCheck) {
        const requestData = {
          type: 'sign_new',
          status: 'partner',
          id: partnerId.value,
          password: partnerPw.value,
          name: partnerName.value,
          birthday: (partnerBirth.value).replace(/[^0-9]/g, ''),
          gender: genderValue,
          phone: (partnerTel.value).replace(/[^0-9]/g, ''),
          email: partnerEmail.value,
          isAgreeEmailMarketingTerms: isEventAgreeChecked,
          appToken: '',
        };

        requestPOST(`${OLD_API_URL}/sign/`, requestData, (status, resData) => {
          if (!status) {
            alert('이메일 또는 아이디가 중복되어 회원가입이 불가능합니다, 변경하여 다시 시도해주세요! 같은 문제가 계속 발생하는 경우 고객센터로 문의주세요!');
          } else {
            const reqData = {
              type: 'sign',
              email: partnerId.value,
              password: partnerPw.value,
              appToken: '',
            };

            requestPOST(`${OLD_API_URL}/sign/`, reqData, (status2, resData2) => {
              if (status2) {
                if (resData2.result) {
                  setJWTTokenData(resData2);
                  setJWTUserData(resData2);

                  // localStorage에서 accessToken 가져오기
                  const auth = localStorage.getItem('auth');
                  const accessToken = auth ? JSON.parse(auth).data.accessToken.token : '';

                  location.href = `/auth/sign/?status=partner&userName=${resData.data.userName}&userID=${resData.data.userID}&signToken=${resData.data.signToken}&levelBadge=${resData.data.levelBadge}&accessToken=${accessToken}`;
                }
              }
            });
          }
        });
      } else if (!isTermsChecked) {
        popupOpen(popupPartnerJoinGuide);
      } else {
        idIsValid(partnerId, validateId(partnerId.value), idMessage);
        pwIsValid(partnerPw, validatePw(partnerPw.value));
        pwCheckIsValid(partnerPwCheck);
        nameIsValid(partnerName, validateName(partnerName.value));
        birthIsValid(partnerBirth, validateBirth(partnerBirth.value));
        telIsValid(partnerTel, validateTel(partnerTel.value));
        emailIsValid(partnerEmail, validateEmail(partnerEmail.value));
        genderCheckStatus();
        termsCheckStatus();
        popupOpen(popupNoticeSubmitErr);
        document.documentElement.scrollIntoView();
      }
    });
  }
};

window.addEventListener('DOMContentLoaded', () => {
  getDataOfPartnerJoin();
});

export {
  validateId, idIsValid, sendPartnerJoin, isValidId, isIdOverlapCheck, setResultSuccessIdValid,
};
